import { createFileRoute } from "@tanstack/react-router";
import { Shell } from "~/components/site-shell";
import { ContentCard, getContent } from "~/components/content";
import { breadcrumbs, jsonLd, seoHead } from "~/config/seo";
export const Route = createFileRoute("/blog/")({
  head: () => ({
    ...seoHead({
      title:
        "Shared hosting guides for websites and business tools | HostRight",
      description:
        "Practical guides for shared hosting, WordPress, databases, caches, and business apps.",
      path: "/blog",
    }),
    scripts: [
      jsonLd(
        breadcrumbs([
          { name: "Home", path: "/" },
          { name: "Journal", path: "/blog" },
        ]),
      ),
    ],
  }),
  component: () => (
    <Shell>
      <section className="paper-grid">
        <div className="mx-auto max-w-7xl px-5 py-24 lg:px-12">
          <h1 className="display text-6xl font-bold">
            Host, build, and keep things moving.
          </h1>
          <p className="mt-7 max-w-xl text-lg leading-8 text-ink/60">
            Short, practical guides for shared hosting, running websites, and
            choosing the tools behind them.
          </p>
        </div>
      </section>
      <div className="mx-auto grid max-w-7xl gap-5 px-5 py-16 md:grid-cols-2 lg:px-12">
        {getContent("blog").map((item) => (
          <ContentCard key={item.slug} item={item} kind="blog" />
        ))}
      </div>
    </Shell>
  ),
});
